"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = listenEscape;
exports.listenClickEscape = listenClickEscape;
exports.listenKeyboardEscape = listenKeyboardEscape;
exports.listenPointerdownEscape = listenPointerdownEscape;
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _map = _interopRequireDefault(require("lodash/fp/map"));
var _compact = _interopRequireDefault(require("lodash/fp/compact"));
var _filter = _interopRequireDefault(require("lodash/fp/filter"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _identity = _interopRequireDefault(require("lodash/fp/identity"));
var _some = _interopRequireDefault(require("lodash/fp/some"));
var isContain = function isContain(target) {
  return function (container) {
    return container.contains(target) || container === target;
  };
};

/**
* @param eventType  Escape event type.
* @param listener  Escape event listener.
* @param escapeExceptions  Elements that don't want to trigger click escape when click on them.
* */

function listenMouseEventEscape(eventType, listener, escapeExceptions) {
  var getDomElement = function getDomElement(item) {
    return item instanceof HTMLElement ? item : item === null || item === void 0 ? void 0 : item.current;
  };
  var eventEscapeHandler = function eventEscapeHandler(e) {
    (0, _compose["default"])((0, _some["default"])(isContain(e.composedPath()[0])), _compact["default"], (0, _map["default"])(getDomElement), _compact["default"])(escapeExceptions) || listener(e);
  };
  document.addEventListener(eventType, eventEscapeHandler, true);
  return function () {
    document.removeEventListener(eventType, eventEscapeHandler, true);
  };
}

/**
* @param listener  Escape event listener.
* @param clickEscapeExceptions  Elements that don't want to trigger click escape when click on them.
* */

function listenClickEscape(listener, clickEscapeExceptions) {
  return listenMouseEventEscape('click', listener, clickEscapeExceptions);
}

/**
* @param listener  Escape event listener.
* @param pointerdownEscapeExceptions  Elements that don't want to trigger click escape when click on them.
* */

function listenPointerdownEscape(listener, pointerdownEscapeExceptions) {
  return listenMouseEventEscape('pointerdown', listener, pointerdownEscapeExceptions);
}
var ESCAPE = 27;

/**
* @param listener  Escape event listener.
* @param targetRefs Event listener targets, document will be used if not specified.
* */

function listenKeyboardEscape(listener, targetRefs) {
  var keyboardEscapeHandler = function keyboardEscapeHandler(e) {
    e.keyCode === ESCAPE && listener(e);
  };
  var addEscapeListener = function addEscapeListener(node) {
    return node.addEventListener('keydown', keyboardEscapeHandler);
  };
  var removeEscapeListener = function removeEscapeListener(node) {
    return node.removeEventListener('keydown', keyboardEscapeHandler);
  };
  targetRefs ? (0, _compose["default"])((0, _map["default"])(addEscapeListener), (0, _filter["default"])(_identity["default"]), (0, _map["default"])((0, _prop["default"])('current')))(targetRefs) : addEscapeListener(document);
  return function () {
    targetRefs ? (0, _compose["default"])((0, _map["default"])(removeEscapeListener), (0, _filter["default"])(_identity["default"]), (0, _map["default"])((0, _prop["default"])('current')))(targetRefs) : removeEscapeListener(document);
  };
}

/**
* @param listener  Escape event listener.
* @param clickEscapeExceptions  Elements that don't want to trigger click escape when click on them.
* */

function listenEscape(listener, clickEscapeExceptions) {
  var removeKeyboardListener = listenKeyboardEscape(listener);
  var removeClickListener = listenClickEscape(listener, clickEscapeExceptions);
  return function () {
    removeKeyboardListener();
    removeClickListener();
  };
}